/**
 * Copyright 2024-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */
import {
  FilterComparisonOperator,
  EventsFilterByFields,
  IncomingEventsFilterByFields,
  PlansFilterByFields,
  CloudResourcesFilterByFields,
  GroupsFilterByFields,
  ActionFilterByFields,
  CloudAccountsFilterableFields,
  PastActionsForResourceFilterByFields,
  FutureActionsForResourceFilterByFields,
  GroupsForResourceFilterByFields,
  ResourcesFilterableFields,
  EventActionResourceReportsFilterByFields,
  ReportsFilterByFields,
} from "~/generated/graphql";
import { isNotNil, isNotEmpty } from "~/tools";

export function createFilterByInput<
  T extends
    | EventsFilterByFields
    | IncomingEventsFilterByFields
    | PlansFilterByFields
    | CloudResourcesFilterByFields
    | GroupsFilterByFields
    | ActionFilterByFields
    | CloudAccountsFilterableFields
    | PastActionsForResourceFilterByFields
    | FutureActionsForResourceFilterByFields
    | GroupsForResourceFilterByFields
    | ResourcesFilterableFields
    | EventActionResourceReportsFilterByFields
    | ReportsFilterByFields
>(field: T, values: string[] | undefined, exclude: boolean | undefined) {
  return isNotNil(values) && isNotEmpty(values)
    ? [
        {
          field,
          operator: exclude
            ? FilterComparisonOperator.Ne
            : FilterComparisonOperator.Eq,
          values,
        },
      ]
    : [];
}
